import { FC, ReactNode } from 'react'

import clsx from 'clsx'

import { Button } from 'shared/ui/button/button.tsx'

import s from './styles.module.scss'

interface Props {
  title: string
  subtitle: string
  buttonText: string
  onClick: () => void
  decoration?: ReactNode
  className?: string
}

export const TripBanner: FC<Props> = ({
  title,
  subtitle,
  buttonText,
  onClick,
  decoration,
  className,
}) => (
  <div className={clsx(s.banner, className)}>
    {decoration}

    <div className={s.content}>
      <p className={clsx('extra-bold-16', s.title)}>{title}</p>
      <p className={clsx('regular-12', s.subtitle)}>{subtitle}</p>
    </div>

    <Button
      className={s.button}
      borderRadius="sm"
      onClick={onClick}
    >
      <span className={clsx('semi-bold-14', s.buttonText)}>{buttonText}</span>
    </Button>
  </div>
)
